import React, { Component } from 'react'
import GoogleAnalytics from 'react-ga'
import ReactPixel from 'react-facebook-pixel'

GoogleAnalytics.initialize( siteData.google_analytics_id )
ReactPixel.init( siteData.facebook_pixel_id, {}, {} )

const PageTracker = ( WrappedComponent, options = {} ) => {
	const trackPage = page => {
		if ( 'production' === process.env.NODE_ENV ) {
			GoogleAnalytics.set({
				page,
				...options
			})
			GoogleAnalytics.pageview( page )

			ReactPixel.pageView()

			if ( page.indexOf( 'subscription-successful' ) > -1 ) {
				ReactPixel.track( 'CompleteRegistration' )
			}
		}
	}

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location.pathname
			trackPage( page )
		}

		componentWillReceiveProps( nextProps ) {
			const currentPage = this.props.location.pathname
			const nextPage = nextProps.location.pathname

			if ( currentPage !== nextPage ) {
				trackPage( nextPage )
			}
		}

		render() {
			return <WrappedComponent { ...this.props } />
		}
	}

	return HOC
}

export default PageTracker



// WEBPACK FOOTER //
// ./components/PageTracker/PageTracker.jsx